var path = '/static/assets/khapps/lab/secondary_navbar/lab_navbar_filters.html';
var html = "<farm-filters hide-farms=\"true\" hide-fields=\"true\"></farm-filters>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;